import { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { buildWhatsAppLink, WHATSAPP_CONTACTS } from "../utils/whatsappContacts";

export default function WhatsAppContactPicker({
  children,
  message = "",
  title = "Escolha um contato",
  subtitle = "Selecione com quem deseja falar no WhatsApp.",
  triggerClassName = "",
  panelClassName = "",
  ariaLabel = "Abrir contatos do WhatsApp",
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open]);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={triggerClassName}
        aria-label={ariaLabel}
      >
        {children}
      </button>

      {open && (
        <div className={`fixed inset-0 z-[100] flex items-center justify-center px-4 ${panelClassName}`}>
          <button
            type="button"
            className="absolute inset-0 bg-black/60"
            aria-label="Fechar seleção de WhatsApp"
            onClick={() => setOpen(false)}
          />

          <div className="relative z-10 w-full max-w-md rounded-2xl border border-white/10 bg-card p-6 shadow-2xl">
            <div className="flex items-start justify-between gap-4 mb-6">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary mb-2">
                  WhatsApp
                </p>
                <h3 className="text-2xl font-bold text-foreground">{title}</h3>
                <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>
              </div>

              <button
                type="button"
                className="rounded-full border border-border px-3 py-1 text-sm text-muted-foreground hover:text-foreground hover:border-primary/50"
                onClick={() => setOpen(false)}
              >
                Fechar
              </button>
            </div>

            <div className="space-y-3">
              {WHATSAPP_CONTACTS.map((contact) => (
                <a
                  key={contact.phone}
                  href={buildWhatsAppLink(contact.phone, message)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between gap-4 rounded-xl border border-border bg-background/60 px-4 py-4 transition-all hover:border-primary/60 hover:bg-primary/5"
                  onClick={() => setOpen(false)}
                >
                  <div>
                    <p className="font-semibold text-foreground">{contact.name}</p>
                    <p className="text-sm text-muted-foreground">{contact.displayPhone}</p>
                  </div>
                  <FaWhatsapp className="text-2xl text-green-600" />
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
